<template>
  <div class="agency-tree">
    <el-popover
      v-model="visible"
      ref="popover"
      placement="bottom"
      width="300"
      trigger="click">
      <AgencyTreeCore
        v-bind="$attrs"
        v-on="$listeners"
        @nodeClick="handleClickNode"
        @checkedChange="handleCheckedChange"
        ref="treeCore"
      ></AgencyTreeCore>
    </el-popover>
    <el-input placeholder="请选择组织机构" v-model="inputValue" readonly>
      <el-button slot="append" icon="el-icon-arrow-down" v-popover:popover></el-button>
    </el-input>
  </div>
</template>

<script>
  import AgencyTreeCore from './AgencyTreeCore.vue';
  import isCRMUser from '@util/isCRMUser.js';

  export default {
    name: 'popover',
    components: {
      AgencyTreeCore
    },
    inheritAttrs: false,
    data () {
      return {
        visible: false,
        inputValue: '',
        isCRMUser: isCRMUser()
      };
    },
    methods: {
      //单选树，点击node
      handleClickNode (agency) {
        if (agency) {
          if ((!this.isCRMUser && agency.type === 4 && agency.disable === false) || (agency.type === 3 && this.isCRMUser)) {
            this.inputValue = `${agency.name}`;
            this.visible = false;
            this.$emit('checkAgencyLeaves', [agency]);
          }
        } else {
          this.inputValue = '';
        }
      },
      //多选树，check节点
      handleCheckedChange (agencyLeaves) {
        let selectedAgencies = [];
        agencyLeaves.forEach((item) => {
          if (this.isCRMUser) {
            item.hotelId && selectedAgencies.push(item);
          } else {
            item.hotelId && item.disable === false && selectedAgencies.push(item);
          }
        });
        this.$emit('checkAgencyLeaves', selectedAgencies);
        let checkedNum = selectedAgencies.length;
        switch (checkedNum) {
          case 0:
            this.inputValue = '';
            break;
          case 1:
            this.inputValue = selectedAgencies[0].name;
            break;
          default:
            this.inputValue = `已选择 ${checkedNum} 家门店`;
        }
      },
      setAgency (agencies) {
        this.$refs.treeCore.setAgency(agencies);
      },
      setAgencyByHotelId (hotelId) {
        this.$refs.treeCore.setAgencyByHotelId(hotelId);
      },
      selectAll () {
        const {data, tree} = this.$refs.treeCore.getData();
        this.$refs.treeCore.setAgency([tree[0].id]);
        this.handleCheckedChange(data);
      }
    }
  };
</script>

<style lang="less">
  .agency-tree {
    input {
      cursor: pointer;
    }
    .el-input-group__append {
      padding: 0;
      .el-button {
        min-width: 75px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// AgencyTree.vue?6ea99a4d